import { render, staticRenderFns } from "./FeatureTree.vue?vue&type=template&id=dd6ad71c&scoped=true"
import script from "./FeatureTree.vue?vue&type=script&lang=ts"
export * from "./FeatureTree.vue?vue&type=script&lang=ts"
import style0 from "./FeatureTree.vue?vue&type=style&index=0&id=dd6ad71c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd6ad71c",
  null
  
)

export default component.exports